import * as React from 'react';
import * as styles from './filter-input.module.scss'
import FilterIcon from '../icons/filter-icon';
import ClearIcon from '../icons/clear-icon';

const FilterInput = ({ value = '', onChange, placeholder }) => {
    const [inputValue, setInputValue] = React.useState(value);

    const inputChange = React.useCallback((val) => {
        setInputValue(val);

        if (onChange) {
            onChange(val);
        }
    }, [onChange])

    return (<>
        <div className={styles.filterInputWrap}>
            <FilterIcon className={styles.filterIcon}></FilterIcon>
            <input className={styles.filterInput} value={inputValue} type='text' placeholder={placeholder} onChange={e => inputChange(e.target.value)}></input>
            {inputValue && <>
                <button className={styles.clearBtn} aria-label='clear' onClick={() => inputChange('')}>
                    <ClearIcon></ClearIcon>
                </button>
            </>}
        </div>
    </>)
}

export default FilterInput;